var map = {
	"./Cancro Europeu/Epidemiologia/Peritêcio 1.webp": "3544",
	"./Cancro Europeu/Epidemiologia/Peritêcio 2.webp": "61ac",
	"./Cancro Europeu/Epidemiologia/ascas com ascosporos.webp": "2bbb",
	"./Cancro Europeu/Epidemiologia/capa1.webp": "f67e",
	"./Cancro Europeu/Epidemiologia/capa2.webp": "7fe0",
	"./Cancro Europeu/Epidemiologia/conídios 1.webp": "b2d3",
	"./Cancro Europeu/Epidemiologia/esporodoquio 1.webp": "58a3",
	"./Cancro Europeu/Epidemiologia/esporodquio 2.webp": "2324",
	"./Cancro Europeu/Etiologia/Esporodóquios e Conídios 1.webp": "6694",
	"./Cancro Europeu/Etiologia/Esporodóquios e Conídios 2.webp": "d377",
	"./Cancro Europeu/Etiologia/Peritécios, Ascas e Ascósporos 1.webp": "64ac",
	"./Cancro Europeu/Etiologia/Peritécios, Ascas e Ascósporos 2.webp": "6d88",
	"./Cancro Europeu/Etiologia/capa1.webp": "0f9c",
	"./Cancro Europeu/Etiologia/capa2.webp": "70ba",
	"./Cancro Europeu/Histórico/Foto 2 Mudas armazenadas em câmara fria.webp": "ad25",
	"./Cancro Europeu/Histórico/capa1.webp": "88fa",
	"./Cancro Europeu/Histórico/capa2.webp": "c816",
	"./Cancro Europeu/Histórico/foto 1 Arranquio de mudas.webp": "5d0c",
	"./Cancro Europeu/Histórico/foto 3 Incineração e mudas (1).webp": "4192",
	"./Cancro Europeu/Importância/Plantas erradicadas 3.webp": "d9d3",
	"./Cancro Europeu/Importância/Plantas rebaixadas e com retirada de ramos laterais 3.webp": "2bac",
	"./Cancro Europeu/Importância/Plantas rebaixadas e com retirada de ramos laterais 4.webp": "642b",
	"./Cancro Europeu/Importância/Plantas rebaixadas e com retirada de ramos laterais 5.webp": "8eb1",
	"./Cancro Europeu/Importância/capa1.webp": "3283",
	"./Cancro Europeu/Importância/capa2.webp": "b967",
	"./Cancro Europeu/Instrução Normativa nº20/Planta rebaixada com novos sintomas.webp": "4d31",
	"./Cancro Europeu/Instrução Normativa nº20/capa1.png": "0be9",
	"./Cancro Europeu/Instrução Normativa nº20/capa2.webp": "2b32",
	"./Cancro Europeu/Instrução Normativa nº20/sintoma em ponto de queda de folha 2.webp": "423c",
	"./Cancro Europeu/Instrução Normativa nº20/sintoma em ponto de queda de folha.webp": "ea50",
	"./Cancro Europeu/Instrução Normativa nº20/sintomas em ferimento de colheita.webp": "86ae",
	"./Cancro Europeu/Sintomatologia/capa1.webp": "b0a2",
	"./Cancro Europeu/Sintomatologia/capa2.webp": "f49b",
	"./Cancro Europeu/Sintomatologia/sintomas estrangulamento.webp": "fa5e",
	"./Cancro Europeu/Sintomatologia/sintomas podridão frutos início.webp": "0c2c",
	"./Cancro Europeu/Sintomatologia/sintomas podridão frutos.webp": "6d2d",
	"./Cancro Europeu/Sintomatologia/sintomas ponto colheita 2.webp": "11f5",
	"./Cancro Europeu/Sintomatologia/sintomas ponto colheita.webp": "5c16",
	"./Cancro Europeu/Sintomatologia/sntomas estrangulamento 2.webp": "d5cf",
	"./Cancro Europeu/Situação do Cancro Europeu da Macieira em Santa Catarina/Falhas nas linhas de plantio devido erradição de plantas 1.webp": "1cf9",
	"./Cancro Europeu/Situação do Cancro Europeu da Macieira em Santa Catarina/Falhas nas linhas de plantio devido erradição de plantas 2.webp": "50d1",
	"./Cancro Europeu/Situação do Cancro Europeu da Macieira em Santa Catarina/Queima de ramos podados.webp": "88d7",
	"./Cancro Europeu/Situação do Cancro Europeu da Macieira em Santa Catarina/Retirada de ramos podados do pomar.webp": "5f5a",
	"./Cancro Europeu/Situação do Cancro Europeu da Macieira em Santa Catarina/capa1.png": "b61f",
	"./Cancro Europeu/Situação do Cancro Europeu da Macieira em Santa Catarina/capa2.webp": "f91c",
	"./Medidas e Manejos/Aquisição de mudas de viveiros com RENASEM/Mudas infectadas por Neonectria ditissima oriundas do viveiro 1.webp": "737d",
	"./Medidas e Manejos/Aquisição de mudas de viveiros com RENASEM/Mudas infectadas por Neonectria ditissima oriundas do viveiro 2.webp": "ed6f",
	"./Medidas e Manejos/Aquisição de mudas de viveiros com RENASEM/Mudas infectadas por Neonectria ditissima oriundas do viveiro 3.webp": "8d4b",
	"./Medidas e Manejos/Aquisição de mudas de viveiros com RENASEM/capa1.webp": "7b57",
	"./Medidas e Manejos/Aquisição de mudas de viveiros com RENASEM/capa2.webp": "5537",
	"./Medidas e Manejos/Ações para conscientização dos fruticultores/Dia de campo 1.webp": "7721",
	"./Medidas e Manejos/Ações para conscientização dos fruticultores/Reunião em comunidades produtoras de macieira 1.webp": "e68b",
	"./Medidas e Manejos/Ações para conscientização dos fruticultores/Reunião em comunidades produtoras de macieira 3.webp": "0c54",
	"./Medidas e Manejos/Ações para conscientização dos fruticultores/capa1.webp": "5429",
	"./Medidas e Manejos/Ações para conscientização dos fruticultores/capa2.webp": "df8a",
	"./Medidas e Manejos/Ações para conscientização dos fruticultores/folder.webp": "8730",
	"./Medidas e Manejos/Clínica fitopatológica/análise inicial 1.webp": "73c2",
	"./Medidas e Manejos/Clínica fitopatológica/análise inicial 2.webp": "b73b",
	"./Medidas e Manejos/Clínica fitopatológica/análise inicial 3.webp": "9562",
	"./Medidas e Manejos/Clínica fitopatológica/capa1.webp": "4328",
	"./Medidas e Manejos/Clínica fitopatológica/capa2.webp": "b0c0f",
	"./Medidas e Manejos/Clínica fitopatológica/processo de isolamento 2.webp": "7025",
	"./Medidas e Manejos/Clínica fitopatológica/processo de isolamento 3.webp": "d8a5",
	"./Medidas e Manejos/Clínica fitopatológica/processo isolamento 1.webp": "e039",
	"./Medidas e Manejos/Desinfestação de ferramentas/Tesoura de poda.webp": "e89f",
	"./Medidas e Manejos/Desinfestação de ferramentas/capa1.webp": "ce21",
	"./Medidas e Manejos/Desinfestação de ferramentas/capa2.webp": "b5c4",
	"./Medidas e Manejos/Desinfestação de ferramentas/serrote de poda.webp": "d296",
	"./Medidas e Manejos/Desinfestação de ferramentas/serrote e tesoura poda e alcool para desisfestação 1.webp": "c77a",
	"./Medidas e Manejos/Desinfestação de ferramentas/serrote e tesoura poda e alcool para desisfestação.webp": "c65e",
	"./Medidas e Manejos/Desinfestação de ferramentas/serrote e tesoura poda.webp": "0019",
	"./Medidas e Manejos/Desinfestação de ferramentas/tesoura de poda 1.webp": "f3c4",
	"./Medidas e Manejos/Erradicação ou Não/Plantas Manejadas para Controle do Cancro Europeu - Cirurgia 1.webp": "066c",
	"./Medidas e Manejos/Erradicação ou Não/Plantas Manejadas para Controle do Cancro Europeu - Cirurgia 2.webp": "a01d",
	"./Medidas e Manejos/Erradicação ou Não/Plantas Manejadas para Controle do Cancro Europeu - Cirurgia 3.webp": "c25b",
	"./Medidas e Manejos/Erradicação ou Não/capa1.webp": "8231",
	"./Medidas e Manejos/Erradicação ou Não/capa2.webp": "310d",
	"./Medidas e Manejos/Fungicidas recomendados/Cuidado tóxico.webp": "7454",
	"./Medidas e Manejos/Fungicidas recomendados/Pulverizador axial.webp": "2043",
	"./Medidas e Manejos/Fungicidas recomendados/Pulverização manual 2.webp": "c9d1",
	"./Medidas e Manejos/Fungicidas recomendados/Pulverização manual.webp": "f63f",
	"./Medidas e Manejos/Fungicidas recomendados/Pulverização turbina.webp": "2f1e",
	"./Medidas e Manejos/Fungicidas recomendados/capa1.png": "b293",
	"./Medidas e Manejos/Fungicidas recomendados/capa2.webp": "a6e5",
	"./Medidas e Manejos/Fungicidas recomendados/pulverização turbina 2.webp": "2132",
	"./Medidas e Manejos/Manejo de poda/Coleta manual de ramos podados.webp": "e804",
	"./Medidas e Manejos/Manejo de poda/O que  não fazer com restos de poda 1.webp": "01aa",
	"./Medidas e Manejos/Manejo de poda/O que  não fazer com restos de poda 2.webp": "27da",
	"./Medidas e Manejos/Manejo de poda/O que fazer com restos de poda 1.webp": "2b00",
	"./Medidas e Manejos/Manejo de poda/Poda Mal Realizada em Ramos Sintomáticos 1.webp": "e100",
	"./Medidas e Manejos/Manejo de poda/Retirada restos de poda no pomar.webp": "a288",
	"./Medidas e Manejos/Manejo de poda/capa1.webp": "9b3a",
	"./Medidas e Manejos/Manejo de poda/capa2.webp": "55ef",
	"./Medidas e Manejos/Manejo de queda de folhas/capa1.webp": "0857",
	"./Medidas e Manejos/Manejo de queda de folhas/capa2.webp": "3ae7",
	"./Medidas e Manejos/Manejo de queda de folhas/queda de  folhas 2.webp": "0f44",
	"./Medidas e Manejos/Manejo de queda de folhas/queda de folhas 3.webp": "4f31",
	"./Medidas e Manejos/Manejo de queda de folhas/queda de folhas 4.webp": "0b33",
	"./Medidas e Manejos/Manejo pré-colheita/Sintomas Cancro Europeu na Colheita 2.webp": "2ca3",
	"./Medidas e Manejos/Manejo pré-colheita/Sintomas Cancro Europeu na Colheita 5.webp": "92d8",
	"./Medidas e Manejos/Manejo pré-colheita/Sintomas Cancro Europeu na Colheita 6.webp": "fe09",
	"./Medidas e Manejos/Manejo pré-colheita/Sintomas Cancro Europeu na Colheita 7.webp": "8f12",
	"./Medidas e Manejos/Manejo pré-colheita/capa1.webp": "ac0c",
	"./Medidas e Manejos/Manejo pré-colheita/capa2.webp": "519c",
	"./Medidas e Manejos/Manejo pós-colheita/Frutos Mumificados com Esporodóquios e Peritécios 1.webp": "c95f",
	"./Medidas e Manejos/Manejo pós-colheita/Frutos Mumificados com Esporodóquios e Peritécios 9.webp": "da3c",
	"./Medidas e Manejos/Manejo pós-colheita/Frutos Mumificados com Esporodóquios e Peritécios3.webp": "fd3c",
	"./Medidas e Manejos/Manejo pós-colheita/capa1.webp": "d424",
	"./Medidas e Manejos/Manejo pós-colheita/capa2.webp": "373d",
	"./Medidas e Manejos/Principais épocas de monitoramento/Arqueamento de Ramos 1.webp": "0e2b",
	"./Medidas e Manejos/Principais épocas de monitoramento/Ferimentos e aberturas naturais macieira - Colheita 3.webp": "8a44",
	"./Medidas e Manejos/Principais épocas de monitoramento/Ferimentos e aberturas naturais macieira - Queda de Petálas 1.webp": "26bf",
	"./Medidas e Manejos/Principais épocas de monitoramento/Ferimentos e aberturas naturais macieira - Queda de folhas 1.webp": "b0f7",
	"./Medidas e Manejos/Principais épocas de monitoramento/Ferimentos e aberturas naturais macieira- Poda.webp": "2fec",
	"./Medidas e Manejos/Principais épocas de monitoramento/Ramo quebrado por Trator.webp": "e322",
	"./Medidas e Manejos/Principais épocas de monitoramento/capa1.webp": "b357",
	"./Medidas e Manejos/Principais épocas de monitoramento/capa2.webp": "9b22",
	"./Medidas e Manejos/Restrição de movimentação dentro dos pomares/Implementos agrícolas.webp": "6ba0",
	"./Medidas e Manejos/Restrição de movimentação dentro dos pomares/Pulverizador e escadas.webp": "318f",
	"./Medidas e Manejos/Restrição de movimentação dentro dos pomares/Roçadeira automática.webp": "9d51",
	"./Medidas e Manejos/Restrição de movimentação dentro dos pomares/Roçadeira manual.webp": "70a5",
	"./Medidas e Manejos/Restrição de movimentação dentro dos pomares/Trator e pulverizador.webp": "1251",
	"./Medidas e Manejos/Restrição de movimentação dentro dos pomares/bins de madeira.webp": "8ae5",
	"./Medidas e Manejos/Restrição de movimentação dentro dos pomares/capa1.webp": "62ec",
	"./Medidas e Manejos/Restrição de movimentação dentro dos pomares/capa2.webp": "e746",
	"./Medidas e Manejos/Uso de quebra ventos/Uso de quebra vento em pomar de maçã 1.webp": "c8e0",
	"./Medidas e Manejos/Uso de quebra ventos/Uso de quebra vento em pomar de maçã 2.webp": "f277",
	"./Medidas e Manejos/Uso de quebra ventos/capa1.webp": "f9c5",
	"./Medidas e Manejos/Uso de quebra ventos/capa2.webp": "0945",
	"./Medidas e Manejos/Uso de quebra ventos/uso_quebra_ventos_1.webp": "6f08",
	"./Medidas e Manejos/Uso de quebra ventos/uso_quebra_ventos_2.webp": "7d84",
	"./Medidas e Manejos/Uso de quebra ventos/uso_quebra_ventos_3.webp": "be78",
	"./Medidas e Manejos/Uso de quebra ventos/uso_quebra_ventos_4.webp": "2f76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9929";